<template>
  <a-card :bordered="false">
    <!-- 操作按钮 -->
    <div class="table-page-search-wrapper">
      <div class="toolbar">
        <a-button type="primary" icon="plus" @click="addOrUpdateHandle()">
          新增
        </a-button>
        <a-button type="default" icon="reload" style="margin-left: 8px" @click="queryList()">
          刷新
        </a-button>
      </div>
    </div>

    <!-- 数据表格 -->
    <a-table size="middle" rowKey="id" bordered
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="false" @change="pageChange">
      <template slot="geoJson" slot-scope="text">
        <div class="geojson-cell" :title="text">{{ text }}</div>
      </template>
      <template slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record)">编辑</a>
        <a-divider type="vertical" />
        <a class="ant-dropdown-link" @click="deleteRow(record.id)">删除</a>
      </template>
    </a-table>

    <!-- 新增/修改弹窗 -->
    <a-modal :title="!currentId ? '新增水厂图层' : '修改水厂图层'" :width="1200" v-model="addOrUpdateVisible" @ok="handleOk"
      :bodyStyle="{ padding: '10px' }" destroyOnClose>
      <a-row :gutter="16">
        <a-col :span="6">
          <a-form :form="addOrUpdateForm" :label-col="{ span: 24 }" :wrapper-col="{ span: 24 }">
            <a-form-item label="水厂名称">
              <a-input v-decorator="['layerName', { rules: [{ required: true, message: '请输入水厂名称!' }] }]"
                placeholder="请输入水厂名称" />
            </a-form-item>
            <a-form-item label="图层GeoJson (可以手动修正)">
              <a-textarea v-decorator="['geoJson', { rules: [{ required: true, message: '请在右侧地图绘制或手动输入水厂范围!' }] }]"
                placeholder="请在右侧地图绘制或手动输入水厂范围" :rows="4" />
            </a-form-item>
            <div class="form-tip">
              提示：请在右侧地图工具栏选择工具。
              <br />
              <img src="@/assets/myImg/1/工具.png" style="width: 14px; vertical-align: middle;" />
              绘制区域：开启后，在地图上点击描点。
              <br />
              <b>高级操作：</b>
              <br />
              1. <b>移动点</b>：开启绘制后，可直接拖动蓝色顶点。
              <br />
              2. <b>中间加点</b>：点击线段中间的半透明小点。
              <br />
              3. <b>删除点</b>：在蓝色顶点上点击<b>鼠标右键</b>选择删除处理。
              <br />
              4. <b>修正坐标</b>：如有真实坐标请根据点顺序点击<b>鼠标右键</b>选择“修正坐标”。
              <br />
              提示：绘制过程中，GeoJSON 数据会实时同步。
            </div>
          </a-form>
        </a-col>
        <a-col :span="18">
          <div class="map-wrapper">
            <water-plant-map v-if="addOrUpdateVisible" mode="edit" :value="addOrUpdateForm.getFieldValue('geoJson')"
              @change="onGeoJsonChange" />
          </div>
        </a-col>
      </a-row>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import WaterPlantMap from '@/components/map/WaterPlantMap.vue'

const columns = [
  {
    title: '水厂名称',
    dataIndex: 'layerName'
  },
  {
    title: '图层GeoJson',
    dataIndex: 'geoJson',
    scopedSlots: { customRender: 'geoJson' }
  },
  {
    title: '创建时间',
    dataIndex: 'createTime'
  },
  {
    title: '更新时间',
    dataIndex: 'updateTime'
  },
  {
    title: '操作',
    dataIndex: 'action',
    width: '150px',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  name: 'WaterPlantArea',
  mixins: [mixinViewModule],
  components: {
    WaterPlantMap
  },
  data () {
    return {
      queryUrl: 'pipe-network/ext/layer/query',
      addOrUpdateUrl: 'pipe-network/ext/layer',
      deleteUrl: 'pipe-network/ext/layer',
      addOrUpdateForm: this.$form.createForm(this),
      needPage: false,
      columns
    }
  },
  methods: {
    addOrUpdateHandle (record) {
      this.isUpdate = false
      this.currentId = record ? record.id : ''
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true
      if (record) {
        this.isUpdate = true
        this.$nextTick(() => {
          this.addOrUpdateForm.setFieldsValue({
            layerName: record.layerName,
            geoJson: record.geoJson
          })
        })
      }
    },
    onGeoJsonChange (val) {
      this.addOrUpdateForm.setFieldsValue({ geoJson: val })
    },
    deleteRow (id) {
      const _this = this
      this.$confirm({
        title: '删除提醒',
        content: '您确认要删除这条数据吗?',
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          _this.$http.delete(_this.deleteUrl, { data: [id] }).then((res) => {
            if (res.code === 0) {
              _this.$message.success('删除成功')
              _this.queryList()
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

/deep/.ant-table-thead>tr>th {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}

.toolbar {
  margin-bottom: 20px;
}

.geojson-cell {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0 auto;
}

.map-wrapper {
  height: 600px;
  border: 1px solid #d9d9d9;
}

.form-tip {
  margin-top: 20px;
  padding: 10px;
  background-color: #fffbe6;
  border: 1px solid #ffe58f;
  border-radius: 4px;
  color: rgba(0, 0, 0, 0.65);
  font-size: 13px;
  line-height: 1.5;
}

/* 确保弹窗内的地图能自适应高度 */
/deep/ .ant-modal-body {
  overflow: hidden;
}
</style>
